import { useState } from "react";
import { downloadExcelFile } from "../../_utils/download_file.util";
import { remissionExcelByMonthYearEvent } from "../../_events/remission/find_remission.event";
import { message } from "antd";

export const useRemissionExcelByMonthYear = () => {

    const [ month, setMonth ] = useState(new Date().getMonth() + 1);
    const [ year, setYear ] = useState(new Date().getFullYear());
    const [ loading, setLoading ] = useState(false);

    const downloadExcel = () => {
        setLoading(true);
        remissionExcelByMonthYearEvent(month, year)
        .then(json => {
            downloadExcelFile(json.data,"Excel_remisiones");
            setLoading(false);
        })
        .catch(err => {
            message.error(err.message);
            setLoading(false);
        });
    }

    return{
        loading, month, setMonth, year, setYear, downloadExcel
    };
}